import { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ErrorMessage } from './ErrorMessage';
// Import the standalone logError function
import { logError } from '../../utilities/ErrorLogger';

type State = {
  error: null | Error;
};

export class ErrorBoundaryComponent extends Component<
  WithTranslation<'errorBoundary'>,
  State
> {
  state: State = {
    error: null,
  };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error): void {
    this.setState({ error: error });

    // Directly call logError
    logError(error);
  }

  render(): React.ReactNode {
    if (!this.state.error) {
      return this.props.children;
    }
    return <ErrorMessage error={this.state.error} />;
  }
}

// Only apply withTranslation HOC
export const ErrorBoundary = withTranslation('globalErrorBoundary')(
  ErrorBoundaryComponent
);
